import axios from "axios";
import ErrorHandler from "../modules/errorHandler";

export const copyLineConfiguration = async (input) => {
  const { data, status } = await axios.post(
    "/api/v1/configurator/copyLineConfiguration",
    input
  );
  if (status === 200 && data.success === true) {
    return data.result;
  }
  return null;
};

export const getQuote = async ({ id, isDealer }) => {
  const { data, status } = await axios.post(
    "/api/v1/quoteManagement/getQuote",
    { id, isDealer }
  );
  if (status === 200 && data.success === true) {
    return data.result;
  }
  return null;
};
export const getQuoteById = async ({ id }) => {
  const { data, status } = await axios.post(
    "/api/v1/quoteManagement/getQuoteById",
    { id }
  );
  if (status === 200 && data.success === true) {
    return data.result;
  }
  return null;
};

export const getQuotes = async ({
  signal,
  limit,
  offset,
  order,
  search,
  username,
  type,
  attributes,
  pid,
  groupId,
}) => {
  const { status, data } = await axios.post(
    "/api/v1/quoteManagement/getQuotes",
    {
      limit,
      offset,
      order,
      search,
      username,
      signal,
      type,
      attributes,
      pid,
      groupId,
    }
  );

  if (status === 200 && data.success === true) {
    return data.result;
  }
  return [];
};

export const getLines = async ({
  signal,
  limit,
  offset,
  order,
  search,
  quoteId,
  username,
  isDealer,
  erpId,
}) => {
  const { status, data } = await axios.post(
    "/api/v1/quoteManagement/getLines",
    {
      limit,
      offset,
      order,
      search,
      signal,
      quoteId,
      username,
      isDealer,
      erpId,
    }
  );

  if (status === 200 && data.success === true) {
    return data.result;
  }
  return [];
};

export const createLine = async ({ input }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/createLine",
      { input }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data.result;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
    return {};
  }
};
export const updateLine = async ({ input, id, _id }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/updateLine",
      { input, id, _id }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
    return {};
  }
};
export const updateLines = async ({ input, quoteId }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/updateLines",
      { input, quoteId }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
    return {};
  }
};
export const deleteLine = async ({ _id, id, quoteId }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/deleteLine",
      { _id, id, quoteId }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
    return {};
  }
};

export const createQuote = async ({ input }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/createQuote",
      { input }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data.result?.quote;
  } catch (error) {
    console.error(error);
    return ErrorHandler.logError(error);
  }
};

export const updateQuote = async ({ id, _id, input, type }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/updateQuote",
      { id, _id, input, type }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};
export const placeOrder = async ({ id, input }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/placeOrder",
      { id, input }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};

export const deleteQuote = async ({ id, _id }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/deleteQuote",
      { id, _id }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};

export const copyQuote = async ({ id, _id }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/copyQuote",
      { id, _id }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data.result;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};

export const createCommunication = async ({ input }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/createCommunication",
      { input }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};

export const updateCommunication = async ({ id, _id, input, type }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/updateCommunication",
      { id, _id, input, type }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};

export const deleteCommunication = async ({ id, _id }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/deleteCommunication",
      { id, _id }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};

export const createAttachment = async ({ input }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/createAttachment",
      { input }
    );

    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};

export const updateAttachment = async ({ id, _id, input, type }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/updateAttachment",
      { id, _id, input, type }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};

export const deleteAttachment = async ({ id, _id }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/quoteManagement/deleteAttachment",
      { id, _id }
    );
    if (status !== 200) ErrorHandler.logError(data);
    return data;
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};

export const getCommunications = async ({ signal, quoteId }) => {
  const { status, data } = await axios.post(
    "/api/v1/quoteManagement/getCommunications",
    {
      quoteId,
      signal,
    }
  );

  if (status === 200 && data.success === true) {
    return data.result;
  }
  return [];
};
export const getAttachments = async ({ signal, quoteId }) => {
  const { status, data } = await axios.post(
    "/api/v1/quoteManagement/getAttachments",
    {
      quoteId,
      signal,
    }
  );

  if (status === 200 && data.success === true) {
    return data.result;
  }
  return [];
};

export const sendOrderStatusEmails = async ({ emails, subject, htmlBody }) => {
  const res = await axios.post(
    "/api/v1/quoteManagement/sendOrderStatusEmails",
    {
      emails,
      subject,
      htmlBody,
    }
  );

  if (res.status === 200) return res.data;

  return null;
};
export const createOrderFromQuote = async (body) => {
  const res = await axios.post("/api/v1/quoteManagement/createOrderFromQuote", {
    ...body,
  });

  if (res.status === 200) return res.data;

  return null;
};
export const createQuoteFromRequest = async ({ body }) => {
  const res = await axios.post(
    "/api/v1/quoteManagement/createQuoteFromRequest",
    { ...body }
  );

  if (res.status === 200) return res.data;

  return null;
};

function dataURItoBlob(dataURI, callback) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(",")[1]);
  // separate out the mime component
  // var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  // write the ArrayBuffer to a blob, and you're done
  var bb = new Blob([ab]);
  return bb;
}

export const downloadFile = async (path, originalName, mimetype) => {
  try {
    const res = await axios.post("/api/v1/quoteManagement/downloadFile", {
      path,
      originalName,
      mimetype,
    });
    if (res.status !== 200) return ErrorHandler.logError(res);
    
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      let linkSource = dataURItoBlob(res.data);

      navigator.msSaveOrOpenBlob(linkSource, originalName);
    } else {
      let linkSource = res.data;
      const downloadLink = document.createElement("a");
      const fileName = originalName;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      downloadLink.remove();
    }
  } catch (error) {
    return ErrorHandler.logError(error);
  }
};

export const createPricingDoc = async ({ body }) => {
  const res = await axios.post("/api/v1/quoteManagement/createPricingDoc", {
    ...body,
  });

  if (res.status === 200) return res.data;

  return null;
};

export const downloadFailedImportCSV = async (failedRows) => {
  try {    
    const res = await axios.get(
      "/api/v1/quoteManagement/downloadFailedImportCSV",
      { responseType: 'blob',
      params: { failedRows }
    }); 
        
    const url = URL.createObjectURL(res.data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'LinesFailedToImport.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
    ErrorHandler.logError(error);
  }
};